import { render, staticRenderFns } from "./QRCodigo.vue?vue&type=template&id=10f987b4&"
import script from "./QRCodigo.vue?vue&type=script&lang=js&"
export * from "./QRCodigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports